import { container, delay } from "tsyringe";

import { IKeepAliveHandler } from "@/Management/KeepAliveHandler";
import { KeepAliveHandlerImpl } from "@/Management/KeepAliveHandlerImpl";
import { INavigationService } from "@/Management/NavigationService";
import { NavigationServiceImpl } from "@/Management/NavigationServiceImpl";
import { IResourceManager } from "@/Management/ResourceManager";
import { ResourceManagerImpl } from "@/Management/ResourceManagerImpl";
import { ILoader } from "@/Utility/Loader";
import { LoaderImpl } from "@/Utility/LoaderImpl";
import { IRADApplication } from "@/Management/RADApplication";
import { RADApplicationImpl } from "@/Management/RADApplicationImpl";
import { IRADEnvironmentProxy } from "@/Communication/RADEnvironmentProxy";
import { RADEnvironmentProxyImpl } from "@/Communication/RADEnvironmentProxyImpl";
import { IUserProvider } from "@/Infrastructure/UserProvider";
import { UserProviderImpl } from "@/Infrastructure/UserProviderImpl";

container.register<IRADApplication>("RADApplication", { useClass: delay(() => RADApplicationImpl) });
container.register<IRADEnvironmentProxy>("RADEnvironmentProxy", { useClass: delay(() => RADEnvironmentProxyImpl) });
container.register<IKeepAliveHandler>("KeepAliveHandler", { useClass: delay(() => KeepAliveHandlerImpl) });
container.register<INavigationService>("NavigationService", { useClass: delay(() => NavigationServiceImpl) });
container.register<IResourceManager>("ResourceManager", { useClass: delay(() => ResourceManagerImpl) });
container.register<ILoader>("Loader", { useClass: delay(() => LoaderImpl) });
container.register<IUserProvider>("UserProvider", { useClass: delay(() => UserProviderImpl) });
